/**
 * 引导用户关注公众号的页面
 */

import React from 'react';
import styles from './FollowUs.module.scss';
import image from './qrcode.jpg';
import logo from './logo.png';

// 关注后可解锁的能力（内联 SVG 图标，避免依赖图标字体）
const FEATURES = [
    {
        bg: '#e6f1fb',
        color: '#378ADD',
        title: '掌握练习进度',
        desc: '随时随地查看孩子练习情况',
        icon: (
            <>
                <polyline points="3 17 9 11 13 15 21 7" />
                <polyline points="15 7 21 7 21 13" />
            </>
        ),
    },
    {
        bg: '#fdecea',
        color: '#e54d42',
        title: '自动错题集',
        desc: '做错的题自动收集，方便复习',
        icon: (
            <path d="M4 5a2 2 0 0 1 2-2h7v16H6a2 2 0 0 0-2 2V5zM20 5a2 2 0 0 0-2-2h-5v16h5a2 2 0 0 1 2 2V5z" />
        ),
    },
    {
        bg: '#f0ebff',
        color: '#7a5cd0',
        title: '精选视频课',
        desc: '名师精讲，难点轻松学',
        icon: (
            <>
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="M10 9l5 3-5 3z" />
            </>
        ),
    },
];

const PLATFORM_NAMES: {[key: string]: string} = {
    baidu: '小度',
    tmall: '天猫精灵',
    xiaoAi: '小爱音箱',
};

export default function FollowUs() {
    const platform = new URLSearchParams(window.location.search).get('platform') || '';
    const platformName = PLATFORM_NAMES[platform] || '';
    const returnText = platformName
        ? `回到${platformName}，对它说`
        : '如果你是从音箱扫码进入，请回到音箱并说';
    const returnHint = platformName
        ? `${platformName}会接着刚才的题目，学习进度不会丢失`
        : '音箱会接着刚才的题目，学习进度不会丢失';
    return (
        <div className={styles.page}>
            {/* 品牌头卡 */}
            <div className={styles.card}>
                <div className={styles.hero}>
                    <div className={styles.avatar}>
                        <img src={logo} className={styles.avatarImg} alt="练习喽公众号头像" />
                    </div>
                    <div>
                        <div className={styles.brandName}>练习喽 <span className={styles.tag}>官方公众号</span></div>
                        <div className={styles.brandSub}>小学僮 · 家长助手，陪孩子高效练习</div>
                    </div>
                </div>
            </div>

            {/* 关注权益 */}
            <div className={styles.card}>
                <div className={styles.secTitle}><span className={styles.secBar} /><span>关注后即可解锁</span></div>
                {
                    FEATURES.map((f, i) => (
                        <div key={f.title} className={styles.feat} style={i === 0 ? { borderTop: 'none' } : undefined}>
                            <div className={styles.featIcon} style={{ background: f.bg }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={f.color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                    {f.icon}
                                </svg>
                            </div>
                            <div>
                                <div className={styles.featTitle}>{f.title}</div>
                                <div className={styles.featDesc}>{f.desc}</div>
                            </div>
                        </div>
                    ))
                }
            </div>

            {/* 二维码 */}
            <div className={styles.card}>
                <div className={styles.qrCard}>
                    <div className={styles.qrTitle}>扫码关注「练习喽」公众号</div>
                    <div className={styles.qrSub}>关注后第一时间收到孩子练习提醒</div>
                    <div className={styles.qrBox}>
                        <img src={image} className={styles.qrImg} alt="练习喽公众号二维码" />
                    </div>
                    <div className={styles.longpress}>长按二维码识别关注</div>
                    <div className={styles.returnGuide}>
                        <div className={styles.returnLabel}>关注完成后</div>
                        <div className={styles.returnText}>{returnText}</div>
                        <div className={styles.returnCommand}>“继续做题”</div>
                        <div className={styles.returnHint}>{returnHint}</div>
                    </div>
                </div>
            </div>
            <div className={styles.foot}>微信扫一扫 · 长按识别二维码</div>
        </div>
    );
}
